<template>
    <div class="apprentice-simple-card">
        <design-2021-apprentice-data-table
            :items="payments"
            :fields="fields"
            :sort-compare="sortCompare">
            <template v-slot:cell(created_at)="row">{{ row.item.date }}</template>
        </design-2021-apprentice-data-table>
    </div>
</template>

<script>
export default {
    name: 'design-2021-payments-index-component',
    props: ['paymentsIn'],
    data() {
        return {
            payments: this.paymentsIn.map((payment) => {
                switch (payment.status) {
                    case 'paid':
                        payment._cellVariants = { status: 'success' };
                        break;

                    case 'canceled':
                        payment._cellVariants = { status: 'danger' };
                        break;

                    case 'expired':
                        payment._cellVariants = { status: 'warning' };
                        break;

                    case 'open':
                        payment._cellVariants = { status: 'info' };
                        break;

                    default:
                        payment._cellVariants = { status: 'info' };
                        break;
                }

                payment.amount = (payment.amount / 100).toFixed(2);

                const formatter = new Intl.NumberFormat('de-DE', {
                    minimumFractionDigits: 2,
                });

                payment.amount = formatter.format(payment.amount);
                payment.amount = '€ ' + payment.amount;

                const date = this.moment(payment.created_at);
                payment.date = date.format('DD MMMM YYYY');

                return payment;
            }),
            fields: [
                {
                    key: 'paymentable.title',
                    label: 'Project ',
                    thClass: 'p-3',
                    tdClass: 'p-3',
                    sortable: true,
                },
                {
                    key: 'paymentable_id',
                    label: 'Id',
                    thClass: 'p-3',
                    tdClass: 'p-3',
                    sortable: true,
                },
                {
                    key: 'user.school.name',
                    label: 'School',
                    thClass: 'p-3',
                    tdClass: 'p-3',
                    sortable: true,
                },
                {
                    key: 'user.school.id',
                    label: 'School Id',
                    thClass: 'p-3',
                    tdClass: 'p-3',
                    sortable: true,
                },
                {
                    key: 'user.full_name',
                    label: this.$t('common.name'),
                    thClass: 'p-3',
                    tdClass: 'p-3',
                    sortable: true,
                },
                {
                    key: 'quantity',
                    label: this.$t('payment.quantity'),
                    thClass: 'p-3',
                    tdClass: 'p-3',
                    sortable: true,
                },
                {
                    key: 'amount',
                    label: this.$t('payment.amount'),
                    thClass: 'p-3',
                    tdClass: 'p-3',
                    sortable: true,
                },
                {
                    key: 'status',
                    label: 'Status',
                    thClass: 'p-3',
                    tdClass: 'p-3',
                    sortable: true,
                },
                {
                    key: 'created_at',
                    label: this.$t('payment.date'),
                    thClass: 'p-3',
                    tdClass: 'p-3',
                    sortable: true,
                },
            ],
        };
    },
    methods: {
        sortCompare(firstRow, secondRow, key) {
            if (key === 'created_at' && firstRow[key] && secondRow[key]) {
                const firstDate = moment(firstRow[key]).format('YYYY-MM-DD HH:mm:ss');
                const secondDate = moment(secondRow[key]).format('YYYY-MM-DD HH:mm:ss');
                return firstDate < secondDate ? -1 : firstDate > secondDate ? 1 : 0;
            } else {
                return false;
            }
        },
    },
};
</script>

<style scoped></style>
